export default {
  "content": "<path d=\"M17.5 9a8.5 8.5 0 11-17 0 8.5 8.5 0 0117 0z\" fill=\"currentColor\"/><path d=\"M8.221 7.055h1.56v6.24h-1.56v-6.24zM8 4.936c0-.251.091-.468.273-.65A.97.97 0 018.988 4c.286 0 .524.091.715.273a.84.84 0 01.299.663c0 .269-.1.494-.299.676-.19.173-.429.26-.715.26a.995.995 0 01-.715-.273A.931.931 0 018 4.936z\" fill=\"#fff\"/>",
  "attrs": {
    "width": "18",
    "height": "18",
    "viewBox": "0 0 18 18",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};